import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const HeadingLabel = styled.label`
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 10px;
`;

export const ProgrammingLanguageLabel = styled.label`
  padding-right: 5px;
`;

export const LabelAndDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.darkGray};
  white-space: pre-wrap;
  font-size: 14px;
`;

export const ExerciseContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  position: relative;
  color: ${colors.darkGray};
  padding: 5px;
`;

export const SyllabusContainer = styled.div`
  padding: 15px;
`;

export const Link = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  color: ${colors.darkGray};

  :hover {
    color: ${colors.fsCyan};
  }
`;

export const LevelNameContainer = styled.div`
  display: contents;
  @media (max-width: 767px) {
    display: block;
  }
`;

export const LevelName = styled.div`
  cursor: pointer;
  border: 1px solid;
  border-radius: 5px;
  padding: 1px 10px 1px 10px;
  margin-left: 10px;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 13px;
  width: fit-content;
  color: ${colors.darkGray};
  border-color: ${colors.darkGray};

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      color: ${colors.fsCyan};
      border-color: ${colors.fsCyan};
    `};

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      color: ${colors.white};
      background-color: ${colors.fsCyan};
      border-color: ${colors.fsCyan};
    `};

  @media (max-width: 767px) {
    margin-left: 0px;
    margin-bottom: 5px;
  }
`;

export const CompletedIcon = styled.div``;

export const ExerciseAndLevelNameContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const ExerciseName = styled.div`
  padding-top: 1px;
`;
